import { render, staticRenderFns } from "./aboutInfo.vue?vue&type=template&id=197d2f5e&"
import script from "./aboutInfo.vue?vue&type=script&lang=js&"
export * from "./aboutInfo.vue?vue&type=script&lang=js&"
import style0 from "./aboutInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports